export const variety_list_static_threshold = [
    'hybrid', 'hybrid_raw',
    'IR8', 'ir8_boiled',
    'IR64', 'ir64_raw',
    'ir64_boiled',
    'gujarat', 'gujarat_raw',
    'gujarat_boiled',
    'gujarat_moti', 'gujarat_moti_raw',
    'basmati', 'basmati_boiled',
    'bori_basmati', 'bori_basmati_boiled',
    'delight_basmati', 'delight_basmati_boiled',
    'sonam', 'sonam_raw',
    'sriram', 'sriram_raw',
    'tukdi', 'tukdi_boiled',
    'sella', 'sella_raw',
    'steam', 'steam_boiled',
    'FCI_RRC',
    'FCI_raw',
    'FCI_parboiled'
]

export const getThresholdValues = (variety) => {
    let threshold_value = {};
    switch (variety) {
        case 'hybrid':
        case 'hybrid_raw':
            threshold_value = {
                discolor_quality: 0.33,
                discolor_area: 0.05,
                chalky_quality: 0.55,
                chalky_area: 0.2,
            }
            break;
        case 'IR8':
        case 'ir8_boiled':
            threshold_value = {
                discolor_quality: 0.11,
                discolor_area: 0.05,
                chalky_quality: 0.44,
                chalky_area: 0.2,
            }
            break;
        case 'IR64':
        case 'ir64_raw':
            threshold_value = {
                discolor_quality: 0.0,
                discolor_area: 0.05,
                chalky_quality: 0.88,
                chalky_area: 0.2,
            }
            break;
        case 'ir64_boiled':
            threshold_value = {
                discolor_quality: 0.55,
                discolor_area: 0.05,
                chalky_quality: 0.44,
                chalky_area: 0.2,
            }
            break;
        case 'gujarat':
        case 'gujarat_raw':
            threshold_value = {
                discolor_quality: 0.0,
                discolor_area: 0.05,
                chalky_quality: 0.66,
                chalky_area: 0.2,
            }
            break;
        case 'gujarat_boiled':
            threshold_value = {
                discolor_quality: 0.33,
                discolor_area: 0.05,
                chalky_quality: 0.44,
                chalky_area: 0.2,
            };
            break;
        case 'gujarat_moti':
        case 'gujarat_moti_raw':
            threshold_value = {
                discolor_quality: 0.33,
                discolor_area: 0.05,
                chalky_quality: 0.44,
                chalky_area: 0.2,
            }
            break;
        case 'basmati':
        case 'basmati_boiled':
        case 'bori_basmati':
        case 'bori_basmati_boiled':
            threshold_value = {
                discolor_quality: 0.55,
                discolor_area: 0.05,
                chalky_quality: 0.22,
                chalky_area: 0.2,
            }
            break;
        case 'delight_basmati':
        case 'delight_basmati_boiled':
            threshold_value = {
                discolor_quality: 0.77,
                discolor_area: 0.05,
                chalky_quality: 0.55,
                chalky_area: 0.2,
            }
            break;
        case 'sonam':
        case 'sonam_raw':
            threshold_value = {
                discolor_quality: 0.11,
                discolor_area: 0.05,
                chalky_quality: 0.22,
                chalky_area: 0.2,
            }
            break;
        case 'sriram':
        case 'sriram_raw':
            threshold_value = {
                discolor_quality: 0.11,
                discolor_area: 0.05,
                chalky_quality: 0.00,
                chalky_area: 0.2,
            }
            break;
        case 'tukdi':
        case 'tukdi_boiled':
            threshold_value = {
                discolor_quality: 0.66,
                discolor_area: 0.05,
                chalky_quality: 0.44,
                chalky_area: 0.2,
            }
            break;
        case 'sella':
        case 'sella_raw':
            threshold_value = {
                discolor_quality: 0.55,
                discolor_area: 0.05,
                chalky_quality: 0.44,
                chalky_area: 0.2,
            }
            break;
        case 'steam':
        case 'steam_boiled':
            threshold_value = {
                discolor_quality: 0.55,
                discolor_area: 0.05,
                chalky_quality: 0.55,
                chalky_area: 0.2,
            }
            break;
        case 'FCI_RRC':
            threshold_value = {
                discolor_quality: 0.0,
                discolor_area: 0.05,
                chalky_quality: 0.55,
                chalky_area: 0.75,
            }
            break;
        case 'FCI_raw':
        case 'FCI_parboiled':
            threshold_value = {
                discolor_quality: 0.11,
                discolor_area: 0.05,
                chalky_quality: 0.0,
                chalky_area: 0.2,
            }
            break;
        default:
            threshold_value = null
            break;
    }
    return threshold_value
}